import View from "../account/views/AddressesPageView";
import components from "./components.js";
components.define("js-addresses-page", View);